// extracted by mini-css-extract-plugin
export var truncate = "_u-0";